import { NavLink } from "react-router-dom";

export function NavigationActionButton(props) {
    return (
        <NavLink
            to={props.href}
            onClick={props.onClick}
            className={`z-30 font-roboto ${
                props.hoverTextClassName ?? "hover:!text-pine"
            } text-[1.6rem] min-w-[144px] px-12 py-6 font-semibold !cursor-pointer rounded-full border-none flex items-center justify-center no-underline ${
                props.className ? props.className : ""
            }`}
        >
            {props.label}
        </NavLink>
    );
}
